import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Nfc, Clock, Heart, Shield } from 'lucide-react';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Hero Section */}
      <section className="pt-20 pb-32 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 tracking-tight leading-tight">
                Tranquilidad para
                <span className="text-blue-600"> dueños</span>,
                eficiencia para
                <span className="text-blue-600"> clínicas</span>
              </h1>
              <p className="text-xl text-slate-600 leading-relaxed">
                TapPet conecta a los dueños de mascotas con las clínicas veterinarias en tiempo real. 
                Un simple tap con NFC abre un enlace seguro que les muestra cada actualización del cuidado de su mascota.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/clinic/login">
                  <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-lg px-8 py-6" data-testid="cta-empezar">
                    Empezar Ahora
                  </Button>
                </Link>
                <Link to="/how-it-works">
                  <Button size="lg" variant="outline" className="text-lg px-8 py-6">
                    Ver Cómo Funciona
                  </Button>
                </Link>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1625321171045-1fea4ac688e9?auto=format&fit=crop&w=1200&q=80" 
                alt="Veterinario con mascota"
                className="rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-slate-900 mb-16">
            ¿Por qué TapPet?
          </h2>
          
          <div className="grid md:grid-cols-4 gap-8">
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Nfc className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Fácil Acceso</h3>
              <p className="text-slate-600">Un simple tap con NFC es todo lo que necesitan los dueños</p>
            </div>
            
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Clock className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Tiempo Real</h3>
              <p className="text-slate-600">Actualizaciones instantáneas del estado de las mascotas</p>
            </div>
            
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Heart className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Tranquilidad</h3>
              <p className="text-slate-600">Los dueños ven cada paso del cuidado de su mascota</p>
            </div>
            
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <Shield className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Seguro</h3>
              <p className="text-slate-600">Enlaces privados que expiran automáticamente</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 to-blue-700 rounded-3xl p-12 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Comienza a dar tranquilidad hoy
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Únete a las clínicas veterinarias que ya confían en TapPet
          </p>
          <Link to="/clinic/login">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-slate-50 text-lg px-8 py-6">
              Crear Cuenta Gratis
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
